export default __webpack_public_path__ + "static/media/GirlIcon.cfa5970f.svg";